import { InstagramIcon, Linkedin, GithubIcon } from "lucide-react";
import "../assets/css/footer.css";
const Footer = () => {
  return (
    <footer className="footer">
      <div className="social-icons">
        <a
          href="https://www.instagram.com/im__jayesh_"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "flex" }}
        >
          <InstagramIcon />{" "}
          <span style={{ padding: "0px 5px" }}>Instagram</span>
        </a>
        <a
          href="https://www.linkedin.com/in/jayesh-suthar-07a1322b5/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "flex" }}
        >
          <Linkedin />{" "}
          <span style={{ padding: "0px 5px" }}>LinkedIn</span>
        </a>
        <a
          href="https://github.com/Im-Jayesh"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "flex" }}
        >
          <GithubIcon />{" "}
          <span style={{ padding: "0px 5px" }}>GitHub</span>
        </a>
      </div>
      <p style={{ margin: "2px" }}>
        © {new Date().getFullYear()} PySpective | All Rights Reserved
      </p>
      <p className="beta-disclaimer" style={{ margin: "2px" }}>
        This product is currently in it's initial stage and may not work with all
        provided codes.
      </p>
    </footer>
  );
};

export default Footer;